import Direct from "./Direct";
import Programmatic from "./Programmatic";
import "./App.css";
import "./assets/fonts/Avenir-Roman-12.ttf";

import React, { useEffect, useState } from "react";
import "./nav.css";

import adLabsLogo from "./assets/AdLabs.svg";

import { ThemeProvider } from "@material-ui/core";
import CssBaseline from "@material-ui/core/CssBaseline";

// import { BlackWhiteToggleButton, ContinueButton, BackButton } from "./Buttons";
import { AppTheme } from "./MaterialTheme";

export const OpacityContext = React.createContext();

// import React, { useState } from 'react';

export default function App() {
  const [selectedApp, setSelectedApp] = useState(null);

  return (
    <ThemeProvider theme={AppTheme}>
      <CssBaseline />
      <div className="bgImageContainer flexColumnCenterClass">
        <div className="logoContainer">
          <img src={adLabsLogo} alt="logo"></img>
        </div>
        {selectedApp === "direct" && (
          <Direct onBackToLanding={() => setSelectedApp(null)} />
        )}
        {selectedApp === "programmatic" && (
          <Programmatic onBackToLanding={() => setSelectedApp(null)} />
        )}
        {!selectedApp && (
          <div className="landing-page">
            <h1>Welcome to AdLabs</h1>
            <p style={{ color: "#cacaca" }}>Choose a workflow to get started</p>
            <div className="landingButtonContainer">
              <button
                className="landing-btn captivateButtonStyle"
                onClick={() => setSelectedApp("direct")}
              >
                Direct
              </button>
              <button
                className="landing-btn captivateButtonStyle"
                onClick={() => setSelectedApp("programmatic")}
              >
                Programmatic
              </button>
            </div>
            <p style={{ color: "#888" }}>v8.2 (updated on 6/16/26)</p>
          </div>
        )}
      </div>
    </ThemeProvider>
  );
}
